var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0001 6.99961C11.0001 7.44144 10.6419 7.79961 10.2001 7.79961H7.8001V10.1996C7.8001 10.6414 7.44193 10.9996 7.0001 10.9996C6.55827 10.9996 6.2001 10.6414 6.2001 10.1996V7.79961H3.8001C3.35827 7.79961 3.0001 7.44144 3.0001 6.99961C3.0001 6.55778 3.35827 6.19961 3.8001 6.19961H6.2001V3.79961C6.2001 3.35778 6.55827 2.99961 7.0001 2.99961C7.44193 2.99961 7.8001 3.35778 7.8001 3.79961V6.19961H10.2001C10.6419 6.19961 11.0001 6.55778 11.0001 6.99961ZM7.0001 0.599609C3.4657 0.599609 0.600098 3.46521 0.600098 6.99961C0.600098 10.534 3.4657 13.3996 7.0001 13.3996C10.5345 13.3996 13.4001 10.534 13.4001 6.99961C13.4001 3.46521 10.5345 0.599609 7.0001 0.599609Z",
    fill: "#011627"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.485a2ed610c09038d37eebe68ee6c7f6.svg";
export { ForwardRef as ReactComponent };